import React from 'react';
import { LocaleProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';

export const LCLocaleProvider = ({ children }) => {
    return <LocaleProvider locale={enUS}>{children}</LocaleProvider>;
};
